import { ChevronDown } from "@faire/slate-icons/ChevronDown";
import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = Omit<React.HTMLAttributes<HTMLSpanElement>, "children">;

export const AccordionChevron = ({ className, ...props }: IProps) => {
  return (
    <span className={chevronStyle.cls({ className })} {...props}>
      <ChevronDown />
    </span>
  );
};

const chevronStyle = tsv({
  base: "fs-accordion__chevron",
});
